/**
 * ReveiwDetailContainer
 * --
 */
import React, { useEffect, useState } from 'react';
import { ReviewApi, ProductApi } from 'api';
import MessageAlert from 'utils';
import { useUserStack } from 'store';
import ReviewDetailPresenter from './ReviewDetailPresenter';

/**----------------------------------------
 * [Component] 총관리자: 리뷰상세 - 컨테이너
 * ----------------------------------------
 */
const ReveiwDetailContainer = ({
  defaultReviewId,
  rawData,
  permission,
  onChange,
  onDelete,
  onReserveReview,
}) => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();

  /* ===== PROPS ===== */

  /* ===== STATE ===== */
  // 모달
  const [loading, setLoading] = useState(false);
  const [isOpened, setIsOpened] = React.useState(false);
  const [modalData, setModalData] = React.useState({});
  const [currentReviewId, _setCurrentReviewId] = useState(
    defaultReviewId ?? null
  );
  const [review, setReview] = useState(rawData);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 데이터 바인딩 함수
   * --
   */
  const handleModalChange = (t, v, callback = null) => {
    let newData = { ...modalData };

    newData[t] = v;
    const d = {
      ...newData,
    };
    setModalData(d);
    if (callback) callback(v);
  };

  /**--------------------
   * 리뷰목록 조회
   * --------------------
   */
  const handleGetReview = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await ReviewApi.getReview(
        currentReviewId,
        {
          join_tables: `["user", "product", "review_file", "point_history"]`,
        }
      );
      if (status !== 200) throw { message };

      setTimeout(() => {
        setReview({
          ...review,
          ...data,
        });
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 리뷰 수정(노출여부, 베스트리뷰, 답변)
   * --------------------
   */
  const handleUpdateReview = async (key, value) => {
    if (value === null || value === undefined) {
      return MessageAlert.warning('데이터를 입력해주세요');
    }
    setLoading(true);
    try {
      const { admin_id, type } = userInfo;
      const newData = {
        review_id: review.review_id,
        [key]:
          // 답변일 경우에 별도 처리
          key === 'review_answer'
            ? [
                ...(review.review_answer ? review.review_answer : []),
                {
                  admin_id, // 답변자 아이디
                  type, // 답변자 권한/유형
                  answer: value,
                },
              ]
            : value,
      };
      const { status, message } = await ReviewApi.updateReview(newData);
      if (status !== 200) throw { message };

      setTimeout(() => {
        MessageAlert.info('상태가 변경되었습니다');
        setReview({
          ...review,
          ...newData,
        });
        onChange(newData);
        setLoading(false);
      }, 750);
    } catch (e) {
      console.log('e: ', e);

      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 리뷰 삭제
   * --------------------
   */
  const handleDeleteReview = async (review_id) => {
    if (
      !window.confirm(
        `삭제한 데이터는 영구적으로 복구할 수 없으며 작성자에게서도 삭제됩니다.\n삭제하시겠습니까?`
      )
    ) {
      return;
    }
    setLoading(true);
    try {
      const { status, message } = await ReviewApi.deleteReview(review_id);
      if (status !== 200) throw { message };

      setTimeout(() => {
        MessageAlert.info('삭제되었습니다');
        onDelete(review_id);
        setLoading(false);
      }, 750);
    } catch (e) {
      console.log('e: ', e);

      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    currentReviewId && handleGetReview();
  }, [currentReviewId]);

  useEffect(() => {
    if (rawData) {
      setReview(rawData);
    }
  }, [rawData]);

  /* ===== RENDER ===== */
  // console.log('review: ', review);

  return (
    <>
      <ReviewDetailPresenter
        loading={loading}
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        modalData={modalData}
        onModalChange={handleModalChange}
        onUpdateReview={handleUpdateReview}
        review={review}
        onDeleteReview={handleDeleteReview}
        onReserveReview={onReserveReview}
        onGetReview={handleGetReview}
        permission={permission}
      />
    </>
  );
};

/* DF */
ReveiwDetailContainer.defaultProps = {
  defaultReviewId: null,
  rawData: null,
  permission: 'ADMIN',
  onChange: () => {},
  onDelete: () => {},
};
export default ReveiwDetailContainer;
